import { useState } from "react";
import { ExternalLink } from "lucide-react";
import { useLang } from "../../lib/i18n";
import { useFetch } from "../../lib/useFetch";
import { PageHeader } from "./About";

import { GEN } from "../../components/site/Img";
import { useContent } from "../../lib/useFetch";

const IMG = GEN.charter;

const PartnerLogo = ({ p }) => {
  const [failed, setFailed] = useState(!p.logo);
  if (failed) return <span className="font-display text-2xl font-black text-[#0A2540]" data-testid={`partner-name-fallback-${p.id}`}>{p.name}</span>;
  return <img src={p.logo} alt={p.name} className="max-h-16 max-w-full object-contain" onError={() => setFailed(true)} />;
};

export default function Partners() {
  const { t, tr } = useLang();
  const content = useContent();
  const { data } = useFetch("/public/partners");
  const groups = {};
  (data || []).forEach((p) => (groups[p.type || "Partner"] = groups[p.type || "Partner"] || []).push(p));
  return (
    <div data-testid="partners-page">
      <PageHeader eyebrow="Partnership" title={t("partners_title")} img={content.images?.fields?.partners_header || IMG} fallback={IMG} />
      <section className="container-x space-y-16 py-24">
        {Object.entries(groups).map(([type, ps]) => (
          <div key={type}>
            <p className="eyebrow">{type}</p>
            <div className="mt-6 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {ps.map((p) => (
                <a key={p.id} href={p.url} target="_blank" rel="noreferrer" className="card-lift group rounded-3xl border border-slate-200 bg-white p-8" data-testid={`partner-card-${p.id}`}>
                  <div className="flex h-24 items-center justify-center rounded-2xl bg-slate-50 p-4">
                    <PartnerLogo p={p} />
                  </div>
                  <h3 className="mt-6 flex items-center justify-between font-display text-lg font-bold text-[#0A2540]">{p.name}<ExternalLink size={16} className="text-slate-400 group-hover:text-[#FF5722]" /></h3>
                  <p className="mt-2 text-sm text-slate-500">{tr(p, "description")}</p>
                </a>
              ))}
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}
